import { type PropertyDefinitions } from '../../types';
import flowchartVerticalSvg from '../../assets/flowchartVertical.svg';
import flowchartHorizontalSvg from '../../assets/flowchartHorizontal.svg';

// DSL describing the available properties for a flowchart diagram.
const properties: PropertyDefinitions = {
  variant: {
    name: 'Collection of properties defining a common variant of the diagram',
    type: 'selectProperties',
    options: [
      {
        value: 'vertical',
        properties: {
          nodeWidth: 150,
          nodeHeight: 40,
          rankGap: 75,
          nodeGap: 75,
          orientation: 'south',
          autoShape: 'true',
        },
        name: 'Layout flowchart from top to bottom',
        icon: flowchartVerticalSvg,
      },
      {
        value: 'horizontal',
        properties: {
          nodeWidth: 150,
          nodeHeight: 40,
          rankGap: 75,
          nodeGap: 75,
          orientation: 'east',
          autoShape: 'true',
        },
        name: 'Layout flowchart from left to right',
        icon: flowchartHorizontalSvg,
      },
    ],
  },

  orientation: {
    name: 'The overall orientation of the diagram',
    type: 'select',
    options: [
      { value: 'south', name: 'Arrange vertically below the first node' },
      { value: 'north', name: 'Arrange vertically above the first node' },
      { value: 'east', name: 'Arrange horizontally left the first node' },
      { value: 'west', name: 'Arrange horizontally right the first node' },
    ],
  },

  autoShape: {
    name: 'Automatically determine the shape of each node based on the connectors',
    type: 'select',
    options: [
      { value: 'true', name: 'Automatically determine the shape' },
      { value: 'false', name: 'Do not automatically change shapes' },
    ],
  },
};

export default properties;
